<template>
  <div class="fixed inset-0 flex items-center justify-center overflow-y-auto modal z-99999">
    <div class="fixed inset-0 h-full w-full bg-gray-400/50" aria-hidden="true" @click="close"></div>

    <div
      :class="[
        'flex flex-col pr-20 pl-10 py-10 relative min-h-100 max-h-[90vh] w-full max-w-175 overflow-hidden rounded-2xl bg-white dark:bg-gray-900',
        props.modalClass,
      ]"
    >
      <button
        @click="close"
        class="transition-color absolute right-5 top-8.5 z-999 flex h-11 w-11 items-center justify-center rounded-full bg-gray-100 text-gray-400 hover:bg-gray-200 hover:text-gray-600 dark:bg-gray-700 dark:bg-white/[0.05] dark:text-gray-400 dark:hover:bg-white/[0.07] dark:hover:text-gray-300"
      >
        <CloseIcon />
      </button>
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { CloseIcon } from '@/shared/icons'

const emit = defineEmits(['close-modal'])
const close = () => emit('close-modal')
const props = defineProps<{ modalClass?: string }>()
</script>
